'use client';

import { useEffect, useRef } from 'react';
import { useRouter } from 'next/navigation';
import { useAuthStore } from '@/stores/auth';
import { api } from '@/lib/api';
import { authDestination } from '@/lib/invitation-continuation';

export default function CallbackPage() {
  const router = useRouter();
  const { setAuth } = useAuthStore();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash.substring(1);
    const params = new URLSearchParams(hash);
    const token = params.get('token');

    if (!token) {
      router.replace('/login');
      return;
    }

    localStorage.setItem('auth_token', token);

    api.auth
      .me()
      .then((response) => {
        setAuth(response.data, token);
        router.replace(authDestination());
      })
      .catch(() => {
        localStorage.removeItem('auth_token');
        router.replace('/login');
      });
  }, [router, setAuth]);

  return (
    <div className="text-center">
      <p className="text-sm text-gray-500">Signing you in...</p>
    </div>
  );
}
